<template>
  <div>
    <navbar class="navbar" />
    <v-card outlined >
      <v-card-text>

        <v-row><v-col><h3>คำสั่งซื้อ</h3></v-col></v-row>

        <v-row>
          <v-divider></v-divider>
        </v-row>

        <search/>

        <v-divider class="mt-3 mb-5"></v-divider>

        <v-row>
          <v-col
            sm="6"
            md="6"
            lg="2"
            cols="12"
            v-if="canCreate"
          >
            <router-link :to="{ name: 'OrderCreate' }" tag="span">
              <v-btn
                color="primary"
                width="100%"
                depressed
                class="pa-5"
              >
                <v-icon class="mr-5">mdi-plus</v-icon>
                เพิ่มรายการ
              </v-btn>
            </router-link>
          </v-col>
        </v-row>

        <v-row>
          <v-col>
            <v-data-table
              :headers="headers"
              :items="itemsTableData"
              item-key="numberOrder"
            >
            <template v-slot:item.total="{item}">
              {{formatCurrency(item.total)}}
            </template>
            <template v-slot:item.createDate="{item}">
              {{moment(item.createDate).format('DD/MM/YYYY')}}
            </template>
            <template v-slot:item.paymentType="{item}">
              <label v-if="item.paymentType === 'bank'">โอนเงินผ่านธนาคาร</label>
              <label v-if="item.paymentType === 'cod'">ชำระเงินปลายทาง</label>
            </template>
            <template v-slot:item.status="{item}">
                <v-chip
                  v-if="item.status === 'pending'"
                  class="ma-2"
                  color="orange"
                  text-color="white"
                  small
                >
                  รอคอย
                </v-chip>
                <v-chip
                  v-if="item.status === 'success'"
                  class="ma-2"
                  color="green"
                  text-color="white"
                  small
                >
                  เสร็จสิ้น
                </v-chip>
            </template>
            <template v-slot:item.actionStatus="{item}">
              <v-btn
                v-if="item.status === 'pending'"
                depressed
                color="primary"
                @click="handleSuccessOrder(item)"
              >
                กดเพื่อยืนยันคำสั่งซื้อ
              </v-btn>
            </template>
            <template v-slot:item.action="{item}">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="view-item mr-2"
                    @click="viewItem(item)"
                    v-if="canView"
                  >
                    mdi-file-eye
                  </v-icon>
                </template>
                <span>ดูรายละเอียด</span>
              </v-tooltip>

              <v-tooltip
                v-if="item.status === 'pending'"
                bottom
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-icon
                    small
                    v-bind="attrs"
                    v-on="on"
                    class="edit-item mr-2"
                    @click="editItem(item)"
                    v-if="canUpdate"
                  >
                    mdi-file-document-edit-outline
                  </v-icon>
                </template>
                <span>แก้ไขรายการคำสั่งซื้อ</span>
              </v-tooltip>

              <!-- <v-icon
                small
                style="color: red"
                @click="deleteItem(item)"
                v-if="canDelete"
              >
                mdi-delete
              </v-icon> -->
            </template>

            </v-data-table>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>

    <v-dialog v-model="dialogSuccess" persistent max-width="290">
      <v-card outlined >
        <v-card-title>ต้องการยืนยันคำสั่งซื้อ !</v-card-title>
        <v-card-text>การยืนยันคำสั่งซื้อไม่สามารถกู้คืนได้ ต้องการยืนยัน ?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogSuccess = false">ยกเลิก</v-btn>
          <v-btn
            color="primary"
            text
            @click="confirmSuccessOrder()"
          >ยืนยัน</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

  </div>
</template>
<script>
import script from '@/views/pages/order/index.script';

export default script;
</script>
